'use client';

import { FC } from 'react';

import { ThemeProvider } from 'styled-components';

import { useGlobalErrorHandler } from '@hooks/useGlobalErrorHandler';
import theme from '@utils/theme';
import InternalServerError from '@page/internal-server-error';

interface ErrorWrapperProps {
  error: Error & { digest?: string };
}

const GlobalError: FC<ErrorWrapperProps> = ({ error }) => {
  const { eventId } = useGlobalErrorHandler(error);

  return (
    <ThemeProvider theme={theme}>
      <InternalServerError eventId={eventId} />
    </ThemeProvider>
  );
};

export default GlobalError;
